import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { IoSearchSharp, IoAddOutline } from 'react-icons/io5';
import { color, CredusButton, CredusText } from 'ui';
import { useQuery } from 'react-query';

import ExamCategoryTable from './tables/ExamCategoryTable';
import ImportCandidatesModal from './modals/ImportCandidatesModal';
import OnboardCandidates from './OnboardCandidates';
import CandidateData from './CandidateData';
import ComponentLoader from '../../ComponentLoader';
import testApi, { IExamCategory } from '../../../../api/test';

export interface ExamCategoryProps {
  setCandidateReUpload: React.Dispatch<React.SetStateAction<boolean>>;
  setShowImportCandidate: React.Dispatch<React.SetStateAction<boolean>>;
  showImportCandidate: boolean;
}

const ExamCategory = ({
  setCandidateReUpload,
  showImportCandidate,
  setShowImportCandidate,
}: ExamCategoryProps) => {
  const [showCandidateData, setShowCandidateData] = useState(false);
  const [examCategory, setExamCategory] = useState<IExamCategory[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const { data, isLoading } = useQuery(['candidateSummary'], () =>
    testApi.getCandidateSummary(1)
  );

  const handleClick = () => {
    setShowImportCandidate(true);
  };

   const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchTerm(e.target.value);
      const _data = data?.data || [];
      const filteredData = _data?.filter((data) => {
        return data.category.toLowerCase().includes(e.target.value.toLowerCase());
      });

      if (filteredData?.length === 0 || !filteredData) {
        return setExamCategory(_data);
      }
      setExamCategory(filteredData);
    };

    useEffect(() => {
        if (data?.data && Array.isArray(data?.data)) {
          setExamCategory(data.data);
        }
      }, [data?.data]);

  return (
    <>
      {showImportCandidate && (
        <ImportCandidatesModal
          showImportCandidate={showImportCandidate}
          setShowImportCandidate={setShowImportCandidate}
          setCandidateReUpload={setCandidateReUpload}
        />
      )}
      {isLoading ? (
        <ComponentLoader loaderText="getting candidate data" />
      ) : data?.data &&
        data?.data?.length !== 0 &&
        Array.isArray(data?.data) ? (
        <div>
          {showCandidateData ? (
            <CandidateData setShowImportCandidate={setShowImportCandidate} />
          ) : (
            <>
              <TopDiv>
                <SearchDiv>
                  <Input
                    placeholder="Try searching for information"
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                  <IoSearchSharp color="#C3CAD9" />
                </SearchDiv>
                <FilterDiv>
                  <CredusText weight="medium" size="xs">
                    Filter by
                  </CredusText>
                  <Div>
                    <CredusText weight="medium" size="xs">
                      Foundational
                    </CredusText>
                  </Div>
                  <CredusButton
                    preffix={<IoAddOutline size={'25px'} />}
                    onClick={handleClick}
                  >
                    Add New
                  </CredusButton>
                </FilterDiv>
              </TopDiv>
              <ExamCategoryTable
                setShowCandidateData={setShowCandidateData}
                candidateData={examCategory}
              />
            </>
          )}
        </div>
      ) : (
        <OnboardCandidates setShowImportCandidate={setShowImportCandidate} />
      )}
    </>
  );
};

export default ExamCategory;

const TopDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 2rem;
`;
const SearchDiv = styled.div`
  width: 326px;
  height: 36px;
  background: ${color.white};
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  box-shadow: 0px 1.44px 3.6px rgba(38, 51, 77, 0.03);
`;

const Input = styled.input`
  outline: none;
  border: none;
  width: 90%;
  &::placeholder {
    color: #adb8cc;
  }
`;

const FilterDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

const Div = styled.div`
  width: 132px;
  height: 36px;
  background: ${color.white};
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  box-shadow: 0px 1.44px 3.6px rgba(38, 51, 77, 0.03);
`;
